import { Pagination } from "@/lib/api";
import React, { useEffect, useState } from "react";
import LoadingGif from "@public/img/loading.gif";
import SectionTopBg from "@public/img/section-top-bg.png";
import PaginationView from "./pagination";
import { PublicListData } from "@/entry/server/user";
import { userRepo } from "@/repo/user-repo";
import ListItem from "../parts/list-item";

type ListsGridProps = {
    defaultLists: PublicListData[];
    defaultPagination: Pagination;
}

export default function ListsGrid({ 
    defaultLists,
    defaultPagination,
}: ListsGridProps) {
    const [lists, setLists] = useState<PublicListData[]>(defaultLists);
    const [pagination, setPagination] = useState<Pagination>(defaultPagination);
    const [isLoading, setIsLoading] = useState(false)
    const [page, setPage] = useState<number>(1);

    useEffect(() => {
        updateQueryParams();
        fetchLists();
    }, [page]);

    const fetchLists = async () => {
        setIsLoading(true);
        const response = await userRepo.getLists(page);
        if (response.status) {
            setLists(response.data!);
            setPagination(response.pagination!);
        }
        setIsLoading(false);
    }

    const updateQueryParams = () => {
        const url = new URL(window.location.href);
        url.searchParams.set("page", page.toString());
        window.history.pushState({}, "", url.toString());
    }

    if (isLoading) {
        return (
            <div className="flex flex-col items-center justify-center h-screen">
                <img src={LoadingGif} alt="Loading" />
                <p className="text-slate-100 text-sm mt-4">در حال بارگذاری...</p>
            </div>
        );
    }

    return (
        <div role="main" className="px-5 lg:px-0 mt-20 mb-10 relative bg-main-bg">
            <img src={SectionTopBg} alt="Section Top Background" className="absolute top-0 bottom-0 left-0 w-full h-auto object-cover" />
            <div className="inset-0 mt-16 flex flex-col items-center gap-8 h-fit bg-main-bg z-10">
                <h1 className="text-4xl font-bold text-slate-100 z-10">لیست‌های کاربران</h1>
                <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 w-full">
                    {lists.map((list) => (
                        <ListItem key={list.id} list={list} />
                    ))}
                </div>

                <PaginationView pagination={pagination} onChange={setPage} />
            </div>
        </div>
    )
}